@if (hasPhoto) {
<forge-avatar [imageUrl]="photoUrl">
</forge-avatar>
}
@else {

@if (hasEmblemText && !useAvatarIcon) {

@if (useAppIcon) {
<forge-avatar [imageUrl]="appIconUrl" [ngClass]="emblemClass" [attr.telemetry]="item.EmblemText">
</forge-avatar>
}
@else {
<forge-avatar [text]="item.EmblemText" [ngStyle]="emblemTextStyles" [attr.telemetry]="item.EmblemText"
    auto-color="true">
</forge-avatar>
}

}

@if (useAvatarIcon) {
<forge-avatar [ngStyle]="emblemTextStyles" [attr.telemetry]="item.EmblemText">
    <mat-icon class="avatar-icon" [fontIcon]="item.AvatarIcon"></mat-icon>
</forge-avatar>
}

<forge-tooltip placement="bottom">
    {{emblemTooltip}}
</forge-tooltip>

}